<template>
    <div>
      <div class="category-top-bar" ref="optionsTopBar">
        <div class="top-bar">
        <p>
          <a class="btn btn-orange btn-icon back" @click="goBack">
            <i class="ti-arrow-left"></i>
            {{ $t('general.back') }}
          </a>
        </p>
        <p class="d-inline-flex">
            <button type="submit" class="btn btn-icon btn-success mar-rt-10 save" style="margin-bottom: 0;" @click.prevent="validate" :title="$t('general.save')">
              <img src="/static/img/icons/save.png">
              {{$t('general.save')}}
            </button>
        </p>
        </div>
      </div>

      <div class="nir-info-note mar-to-15" v-html="$t('gestiune.nirInfoNote')"></div>

      <div class="card mar-to-15">
        <div class="card-content">
          <form class="clearfix row">
              <div class="col-md-12">
                <p>{{$t('gestiune.noteEntries')}}</p>
                <hr class="sm">
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.locatie') }}</label>
                  <select class="form-control" v-model="selectedLocationId" :disabled="isEdit || isNir">
                    <option value="" disabled>Selectează locația</option>
                    <optgroup
                      v-for="group in groupedLocations"
                      :key="group.vat"
                      :label="`VAT: ${group.vat}`"
                    >
                      <option
                        v-for="loc in group.locations"
                        :key="loc.true_id"
                        :value="loc.true_id"
                      >
                        {{ loc.name }}
                      </option>
                    </optgroup>
                  </select>
                </div>
              </div>

              <div
                class="col-md-2"
                v-if="!isNir && (!isEdit || (isEdit && selectedGestiuneId))"
              >
                <div class="form-group">
                  <label>{{ $t('gestiune.gestiune') }}*</label>
                  <select
                    v-model="selectedGestiuneId"
                    class="form-control"
                    :disabled="!selectedLocationId || (isEdit && selectedGestiuneId)"
                    v-validate="modelValidate.selectedGestiuneId"
                    @click.prevent="checkGestiuneChange"
                  >
                    <option :value="null" disabled>Selectează gestiunea</option>

                    <!-- Dacă e edit și avem gestiune → afișăm doar gestiunea salvată -->
                    <option
                      v-if="isEdit && selectedGestiuneId"
                      :value="selectedGestiuneId"
                    >
                      {{ getGestiuneNameById(selectedGestiuneId) }}
                    </option>

                    <!-- Dacă NU e edit → afișăm toate gestiunile filtrate -->
                    <option
                      v-else
                      v-for="gestiune in filteredGestiuni"
                      :key="gestiune._id"
                      :value="gestiune._id"
                    >
                      {{ gestiune.name }}
                    </option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.supplier')}}*</label>
                  <v-select
                    v-model="supplierSelected"
                    :options="supplierResults"
                    label="nume"
                    placeholder="Caută un furnizor..."
                    :filterable="false"
                    :disabled="!selectedLocation"
                    @search="fetchSuppliers"
                    @input="onSupplierSelect"
                  />

                  <div class="v-select-loader" v-if="loading"></div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.codeFiscalFurnizor')}}*</label>
                  <input type="text" :placeholder="$t('gestiune.codeFiscalFurnizor')" name="codeFiscalFurnizor" v-model="codeFiscalFurnizor" v-validate="modelValidate.codeFiscalFurnizor" class="form-control">
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.dataDocument')}}*</label>
                  <input type="datetime-local" name="dataDocument" v-model="dataDocument" :max="today" v-validate="modelValidate.dataDocument" class="form-control">
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.dataInStoc')}}*</label>
                  <input type="datetime-local" name="dataInStoc" v-model="dataInStoc" :max="today" @change="checkValidatedAfter('dataInStoc')" v-validate="modelValidate.dataInStoc" class="form-control">
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.dataScadenta')}}</label>
                  <input type="datetime-local" name="dataScadenta" :max="today" v-model="dataScadenta" class="form-control">
                </div>
              </div>

              <div class="col-md-2">
                  <div class="form-group">
                      <label>{{ $t('gestiune.tipDocument') }}*</label>
                      <select v-model="tipDocument" v-validate="modelValidate.tipDocument" class="form-control" :disabled="isNir || isInvoiceSupplier">
                          <option value="" disabled>Selectează tip document</option>
                          <option value="factura">Factura</option>
                          <option value="aviz">Aviz</option>
                          <option value="bon_fiscal">Bon Fiscal</option>
                          <option value="altul">Altul</option>
                      </select>
                  </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.nrDocument')}}*</label>
                  <input type="text" :placeholder="$t('gestiune.nrDocument')" name="nrDocument" v-model="nrDocument" v-validate="modelValidate.nrDocument" class="form-control" :disabled="isNir || isInvoiceSupplier">
                </div>
              </div>

              <div class="col-md-1">
                <label>{{ $t('invoice.series') }}*</label>
                <select class="form-control" v-model="seriesNumber" @change="updateNumber" :disabled="isEdit">
                  <option value="" disabled>{{ $t('invoice.selectSeries') }}</option>
                  <option
                    v-for="series in seriesOptionsWithAdd"
                    :key="series.id || series.series"
                    :value="series.id || series.series"
                  >
                    {{ series.nume || series.series }}
                  </option>
                </select>
              </div>

              <div class="col-md-2">
                <label>{{ $t('gestiune.currentNumber') }}</label>
                <input type="number" class="form-control" v-model="currentNumber" :disabled="!seriesNumber || isEdit" />
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{$t('gestiune.valoare')}}</label>
                  <input type="text" :placeholder="$t('gestiune.valoare')" name="valoare" v-model="valoare" class="form-control" :disabled="isNir || isInvoiceSupplier">
                </div>
              </div>

              <div class="col-md-1">
                <div class="form-group">
                  <label>{{ $t('gestiune.currency') }}</label>
                  <select v-model="currency" class="form-control">
                      <option value="RON">RON</option>
                      <option value="EUR">EURO</option>
                  </select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="form-group">
                  <label>{{ $t('gestiune.precizie') }}</label>
                  <select v-model="precizie" class="form-control">
                      <option value="2 zecimale">2 zecimale</option>
                      <option value="3 zecimale">3 zecimale</option>
                      <option value="4 zecimale">4 zecimale</option>
                  </select>
                </div>
              </div>
          </form>
        </div>
      </div>

      <div class="card mar-to-15 tableInvoice">
        <div class="card-content">
          <div class="col-md-12">
            <p>{{$t('gestiune.addProductInNir')}}</p>
            <hr class="sm">
          </div>

          <div class="tableInvoice" :class="{ 'invoice-supplier-mode': isInvoiceSupplier }" style="overflow-x: auto; width: 100%;">
            <table class="table">
              <thead>
                <tr>
                  <th>{{ $t('gestiune.code') }}</th>
                  <th>{{ $t('gestiune.name') }}</th>
                  <th>{{ $t('gestiune.categoria') }}</th>
                  <th v-if="(isEdit && !selectedGestiuneId) || isNir">
                    {{ $t('gestiune.gestiune') }}
                  </th>
                  <th>{{ $t('gestiune.um') }}</th>
                  <th>{{ $t('gestiune.cantitate') }}</th>
                  <th>{{ $t('gestiune.tva') }}</th>
                  <th>{{ $t('gestiune.pretFaraTva') }}</th>
                  <th>{{ $t('gestiune.currency') }}</th>
                  <th>{{ $t('gestiune.valoare') }}</th>
                  <th>Val. TVA</th>
                  <th v-if="hasMarfaProducts && !isInvoiceSupplier">Preț vânzare (TVA incl.)</th>
                  <th v-if="hasMarfaProducts && !isInvoiceSupplier">TVA %</th>
                  <th v-if="hasMarfaProducts && !isInvoiceSupplier">Adaos total (RON)</th>
                  <th v-if="!isNir && !isInvoiceSupplier && !invoiceSupplierId">{{ $t('general.actions') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in tableData" :key="index">
                  <td>{{ row.nr }}</td>

                  <!-- Nume produs -->
                  <td>
                    <div v-if="isInvoiceSupplier" class="invoice-product-wrapper">
                      <span class="supplier-product-name">{{ $t('gestiune.name') }}: {{ row.productInvoiceSupplier }}</span>
                      <v-select
                        v-model="row.productName"
                        :options="searchResults"
                        label="name"
                        placeholder="Mapeaza produsul..."
                        :filterable="false"
                        @search="fetchProducts"
                        @input="(val) => onProductSelect(val, row)"
                      >
                        <template #no-options>
                          <span v-if="!loading">Niciun produs găsit</span>
                        </template>
                      </v-select>
                    </div>
                    <span v-else>{{ row.productName }}</span>
                  </td>

                  <td>{{ row.categoria }}</td>

                  <!-- Gestiune -->
                  <td v-if="(isEdit && !selectedGestiuneId) || isNir">
                    {{ getGestiuneNameById(row.gestiune) }}
                  </td>

                  <!-- Unită măsură -->
                  <td>
                    <template v-if="isInvoiceSupplier">
                      <span class="supplier-product-name">Factură: {{ getUnitText(row.umInvoiceSupplier) }}</span>
                      <div class="invoice-supplier-um-edit">
                        <span v-if="row.um" class="supplier-product-name">Stoc: {{ row.um }}</span>
                        <select
                          v-model="row.umDocument"
                          class="form-control invoice-supplier-select"
                          @change="onInvoiceSupplierUnitChange(row)"
                        >
                          <option
                            v-for="unitShort in getRowDocumentUmOptions(row)"
                            :key="unitShort"
                            :value="unitShort"
                          >
                            {{ unitShort }}
                          </option>
                        </select>
                        <small class="supplier-product-hint">UM recepție</small>
                      </div>
                    </template>
                    <template v-else>{{ row.um }}</template>
                  </td>

                  <!-- Cantitate -->
                  <td>
                    <template v-if="isInvoiceSupplier">
                      <span class="supplier-product-name">Factură: {{ row.quantityInvoiceSupplier }} {{ getUnitText(row.umInvoiceSupplier) }}</span>
                      <input
                        type="number"
                        class="form-control invoice-supplier-qty"
                        v-model.number="row.cantitateDocument"
                        min="0.0001"
                        step="any"
                        required
                        :disabled="!row.um"
                        @input="onInvoiceSupplierQuantityInput(row)"
                      />
                    </template>
                    <template v-else>{{ row.cantitate }}</template>
                  </td>

                  <!-- TVA -->
                  <td>{{ row.tva }}</td>

                  <!-- Pret fara TVA -->
                  <td>
                    <template v-if="isInvoiceSupplier">
                      <span class="supplier-product-name">Factură: {{ row.priceInvoiceSupplier != null ? Number(row.priceInvoiceSupplier).toFixed(2) : '' }} / {{ getUnitText(row.umInvoiceSupplier) }}</span>
                      <input
                        type="number"
                        class="form-control invoice-supplier-price"
                        :value="row.pretInvoiceSupplier != null ? Number(row.pretInvoiceSupplier).toFixed(3) : ''"
                        disabled
                      />
                    </template>
                    <template v-else>{{ Number(row.pretFaraTva).toFixed(4) }}</template>
                  </td>

                  <!-- Currency -->
                  <td>{{ row.currency }}</td>

                  <!-- Valoare calculata -->
                  <td>
                    <template v-if="isInvoiceSupplier">
                      <span class="supplier-product-name">Factură: {{ row.valoareInvoiceSupplier != null ? Number(row.valoareInvoiceSupplier).toFixed(2) : '' }} {{ row.currency }}</span>
                      <input
                        type="number"
                        class="form-control invoice-supplier-value"
                        :value="row.valoareCalculata != null ? Number(row.valoareCalculata).toFixed(2) : ''"
                        disabled
                      />
                    </template>
                    <template v-else>
                      {{ !isNaN(row.valoareCalculata) && row.valoareCalculata !== null ? row.valoareCalculata.toFixed(2) : row.valoareCalculata }} {{ row.currency }}
                    </template>
                  </td>

                  <!-- Val TVA -->
                  <td>
                    {{ !isNaN(row.valoareTva) && row.valoareTva !== null ? row.valoareTva.toFixed(2) : row.valoareTva }} {{ row.currency }}
                  </td>

                  <!-- Pret vanzare (Marfa) -->
                  <td v-if="hasMarfaProducts && !isInvoiceSupplier">
                    <span v-if="row.categoria === 'Marfa'">
                      {{ (!isNaN(Number(row.price)) && row.price !== null) ? Number(row.price).toFixed(2) : row.price }} {{ row.currency }}
                    </span>
                  </td>

                  <!-- TVA % (Marfa) -->
                  <td v-if="hasMarfaProducts && !isInvoiceSupplier">
                    <span v-if="row.categoria === 'Marfa'">{{ row.tvaProdusVanzare }} %</span>
                  </td>

                  <!-- Adaos total (Marfa) -->
                  <td v-if="hasMarfaProducts && !isInvoiceSupplier">
                    <span v-if="row.categoria === 'Marfa'">{{ !isNaN(row.adaosTotal) && row.adaosTotal !== null ? row.adaosTotal.toFixed(2) : row.adaosTotal }} {{ row.currency }}</span>
                  </td>

                  <!-- Actiuni -->
                  <td v-if="!isNir && !isInvoiceSupplier && !invoiceSupplierId">
                    <el-dropdown trigger="click" placement="bottom-end">
                      <span class="arrow-box">&#9662;</span>
                      <el-dropdown-menu slot="dropdown" class="custom-dropdown-menu">
                        <el-dropdown-item @click.native="editRow(row)">{{$t('general.edit')}}</el-dropdown-item>
                        <el-dropdown-item @click.native="deleteRow(row)">{{$t('general.delete')}}</el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </td>
                </tr>

                <tr v-if="tableData.length === 0">
                  <td :colspan="15" style="text-align: center; color: #909399; padding: 20px;">
                    {{ $t('gestiune.emptyData') }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <button
            v-if="!isNir || !isInvoiceSupplier"
            class="btn add mar-rt-10 mar-bt-5 mar-to-15"
            @click.prevent="openAddProductModal"
            :title="$t('general.add') + ' ' + $t('settingUsers.single')"
            :disabled="!selectedLocationId || isInvoiceSupplier || invoiceSupplierId"
          >
            <img src="/static/img/icons/add.png">
            {{$t('gestiune.addProduct')}}
          </button>

          <!-- Totaluri sub tabel -->
          <div class="totals-container">
            <div v-if="totalPretVanzare > 0" class="total-row">
              <span class="label">Valoare totală preț vânzare:</span>
              <span class="value">{{ totalPretVanzare.toFixed(2) }} RON</span>
            </div>
            <div v-if="valoareNir > 0" class="total-row">
              <span class="label">Valoare NIR:</span>
              <span class="value">{{ valoareNir.toFixed(2) }} RON</span>
            </div>
            <div class="total-row">
              <span class="label">Total fara TVA:</span>
              <span class="value">{{ totalFaraTva.toFixed(2) }} RON</span>
            </div>
            <div class="total-row">
              <span class="label">Total TVA pret achizitie:</span>
              <span class="value">{{ totalTva.toFixed(2) }} RON</span>
            </div>
            <div class="total-row" v-if="totalCorectie !== 0">
              <span class="label">Corectie Document:</span>
              <span class="value">{{ totalCorectie.toFixed(2) }} RON</span>
            </div>
            <div class="total-row total-final">
              <span class="label">Total:</span>
              <span class="value">{{ totalFinal.toFixed(2) }} RON</span>
            </div>
          </div>
        </div>
      </div>

      <div class="card mar-to-15 col-md-6">
        <div class="card-content">
          <h5>Detalii Client</h5>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="delegat">Delegat</label>
                <input
                  type="text"
                  id="delegat"
                  class="form-control"
                  v-model="extraFields.delegat"
                  placeholder="Numele delegatului" />
              </div>
              <div class="form-group">
                <label for="carteIdentitate">Carte Identitate</label>
                <input
                  type="text"
                  id="carteIdentitate"
                  class="form-control"
                  v-model="extraFields.carteIdentitate"
                  placeholder="Seria și numărul cărții de identitate" />
              </div>
              <div class="form-group">
                <label for="auto">Auto</label>
                <input
                  type="text"
                  id="auto"
                  class="form-control"
                  v-model="extraFields.auto"
                  placeholder="Marca și modelul auto" />
              </div>
              <div class="form-group">
                <label for="notaInterna">Notă internă (nu va fi vizibilă pentru furnizor)</label>
                <textarea
                  id="notaInterna"
                  class="form-control"
                  v-model="extraFields.notaInterna"
                  placeholder="Informații suplimentare"></textarea>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vmodal name="addProductModal" height="auto" width="1200" class="addProductModal">
        <div class="card">
          <div class="card-content">
            <div class="modal-header">
              <p>{{$t('gestiune.addProduct')}}</p>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <div class="col-md-6">
                    <div class="form-group mt-3">
                      <label>Cauta dupa categoria</label>
                      <select v-model="selectedCategory" class="form-control">
                        <option value="">All</option>
                        <option
                          v-for="category in productCategories"
                          :key="category.value"
                          :value="category.value"
                        >
                          {{ category.label }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.productName')}}*</label>
                      <v-select
                        v-model="item.productName"
                        :options="searchResults"
                        label="name"
                        placeholder="Caută un produs..."
                        :filterable="false"
                        @search="fetchProducts"
                        @input="(val) => onProductSelect(val, null)"
                      >
                        <template #no-options>
                          <span v-if="!loading">Niciun produs găsit</span>
                        </template>
                      </v-select>

                      <div v-if="loading" class="v-select-loader"></div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.codeProduct')}}*</label>
                      <input type="text" :placeholder="$t('gestiune.codeProduct')" v-model="item.nr" class="form-control" disabled/>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.um')}}*</label>
                      <select v-model="item.um" class="form-control" disabled>
                        <option :value="item.um">{{item.um}}</option>
                      </select>
                    </div>
                  </div>
<!--
                  <div class="col-md-6">
                    <div class="form-group">
                        <label>{{$t('gestiune.gestiune')}}*</label>
                        <select v-model="item.gestiune" class="form-control">
                          <option value="" disabled>Selectează gestiunea</option>

                          <template v-if="!addItem">
                          <option :value="item.gestiune">
                              {{ getGestiuneNameById(item.gestiune) }}
                            </option>
                          </template>

                          <template v-else>
                            <option v-for="gestiune in filteredGestiuni" :key="gestiune._id" :value="gestiune._id">
                              {{ gestiune.name }}
                            </option>
                          </template>
                        </select>
                    </div>
                  </div> -->

                  <div class="col-md-6" v-if="isEdit && !selectedGestiuneId">
                    <div class="form-group">
                      <label>{{$t('gestiune.gestiune')}}*</label>
                      <select v-model="item.gestiune" class="form-control">
                        <option :value="null" disabled>Selectează gestiunea</option>

                        <!-- afișăm toate gestiunile filtrate -->
                        <option
                          v-for="gestiune in filteredGestiuni"
                          :key="gestiune._id"
                          :value="gestiune._id"
                        >
                          {{ gestiune.name }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.currency')}}*</label>
                      <select v-model="item.currency" class="form-control">
                        <option value="RON">RON</option>
                        <option value="EUR">EURO</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.tva')}}*</label>
                      <select v-model="item.tva" class="form-control">
                          <option disabled value="">Selectează TVA</option>
                          <option
                            v-for="vat in vats"
                            :key="vat.tax_id"
                            :label="`${vat.amount} %`"
                            :value="Number(vat.amount)"
                          />
                      </select>
                    </div>
                  </div>

                  <div class="col-md-12">
                    <div class="form-group">
                      <label>Valoare total in LEI pentru {{ selectedQuantity }} {{ getDocumentUmShort() }}</label>
                      <input
                        type="number"
                        min="0"
                        :placeholder="'Valoare totală'"
                        v-model.number="totalValue"
                        class="form-control"
                        @input="calculateUnitPrice"
                      />
                      <small class="form-text" style="color: #000;">
                        Calculator consultativ: completează valoarea totală și cantitatea pentru a afla prețul de achiziție pe unitate. Dacă nu completezi, nu se modifică nimic.
                      </small>
                    </div>
                  </div>

                <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.priceAchizitie')}} in {{ selectedUnit.short || item.um }}*</label>
                      <div class="d-flex">
                        <input
                          type="number"
                          :placeholder="$t('gestiune.priceAchizitie')"
                          v-model.number="item.pretFaraTva"
                          min="0"
                          class="form-control"
                          style="margin-right: 8px;"
                          @input="onInputNumber"
                        />
                        <select v-model="item.valoare" class="form-control" style="max-width: 130px;">
                          <option value="cu_tva">cu TVA</option>
                          <option value="fara_tva">fără TVA</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.cantitate')}} in {{ selectedUnit.short || item.um }} *</label>
                      <input type="number" :placeholder="$t('gestiune.cantitate')" v-model.number="selectedQuantity" class="form-control" @input="onInputQuantity"/>
                    </div>
                  </div>

                  <template v-if="1">
                    <div class="col-md-6">
                      <label>UM document intrare</label>
                      <select v-model="selectedUnit" :disabled="!(unit_calc && unit_calc.length)" class="form-control" @change="onDocumentUnitChange">
                        <option :value="item.um">{{item.um}}</option>
                        <template v-for="unit in unit_calc">
                          <option :value="unit">{{unit.short}}</option>
                        </template>
                      </select>
                    </div>
                  </template>

                  <template v-if="unit_calc && unit_calc.length">
                    <div class="col-md-12">
                      <label for=""> Gestiunea incarca {{item.cantitate}} {{item.um}}</label>
                    </div>
                  </template>
                </div>

                <div class="col-md-6">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label>{{$t('gestiune.pretVanzare')}}</label>
                      <input
                        type="text"
                        class="form-control"
                        :value="item.price != null ? item.price + ' ' + item.currency : ''"
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>TVA vânzare</label>
                      <input
                        type="text"
                        class="form-control"
                        :value="item.tvaProdusVanzare != null ? item.tvaProdusVanzare + ' %' : ''"
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Adaos pe item (RON)</label>
                      <input
                        type="text"
                        class="form-control"
                        :value="item.adaosLinie != null ? item.adaosLinie.toFixed(2) : '0.00'"
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Adaos total (RON)</label>
                      <input
                        type="text"
                        class="form-control"
                        :value="item.adaosTotal != null ? item.adaosTotal.toFixed(2) : '0.00'"
                        disabled
                      />
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="form-group">
                      <label>Adaos procentual (%)</label>
                      <input
                        type="text"
                        class="form-control"
                        :value="item.adaosProc != null ? item.adaosProc.toFixed(2) + ' %' : '0 %'"
                        disabled
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <div class="button-group">
                <a class="btn btn-danger btn-icon mar-rt-10 delete" @click="$modal.hide('addProductModal')">
                  {{$t('general.cancel2')}}
                </a>
                <button class="btn btn-icon btn-success mar-rt-10 save" @click="saveProduct">
                  {{$t('general.save')}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </vmodal>

      <vmodal name="addProduct" height="auto" width="970" class="addProductModal">
        <div class="card">
          <div class="card-content">
            <div class="modal-header">
              <p>{{ $t('gestiune.addProduct') }}</p>
            </div>
            <div class="modal-body">

              <!-- Additional Input Fields -->
              <div class="row mt-3">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t('gestiune.productName') }}*</label>
                    <input type="text" :placeholder="$t('gestiune.productName')" v-model="name" class="form-control"/>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t('gestiune.productDescription') }}*</label>
                    <input type="text" :placeholder="$t('gestiune.productDescription')" v-model="description" class="form-control"/>
                  </div>
                </div>
                <div class="col-md-6">
                    <div class="form-group">
                        <label>{{ $t('gestiune.type') }}*</label>
                        <select v-model="type" class="form-control">
                          <option value="" disabled>Selectează opțiunea</option>
                          <option
                            v-for="category in categories"
                            :key="category.value"
                            :value="category.value"
                          >
                            {{ category.label }}
                          </option>
                        </select>
                    </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t('gestiune.um') }} *</label>
                    <select v-model="umProduct" class="form-control">
                      <option :value="null" disabled>Selectează optiunea</option>
                      <template v-for="unit in mesurementsUnits">
                        <option :value="unit.short">{{unit.short}}</option>
                      </template>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t('gestiune.currency') }} *</label>
                    <select v-model="currencyProduct" class="form-control">
                        <option value="RON">RON</option>
                        <option value="EUR">EURO</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label>{{ $t('gestiune.codeProduct') }}*</label>
                    <input type="text" :placeholder="$t('gestiune.codeProduct')" v-model="code" class="form-control"/>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="button-group">
                <a @click="closeProduct" class="btn btn-danger btn-icon mar-rt-10 delete">{{ $t('general.cancel2') }}</a>
                <button @click.prevent="addProductApi" class="btn btn-icon btn-success mar-rt-10 save">{{ $t('general.save') }}</button>
              </div>
            </div>
          </div>
        </div>
      </vmodal>

      <ManagementSuppliersAdd :groupedLocations="groupedLocations"/>
      <ManagementSeriesAdd
        :locations="locations"
        :grouped-locations="groupedLocations"
        :vat-number="selectedLocation ? selectedLocation.inv_fiscal_code : ''"
        @getSeries="getSeries"
      />
    </div>
</template>

<script>
  import PSwitch from 'src/components/UIComponents/Switch.vue'
  import ManagementSuppliersAdd from '../Suppliers/ManagementSuppliersAdd.vue'
  import ManagementSeriesAdd from '../../Management/ManagementSeriesAdd.vue'
  import swal from 'sweetalert2'

  function getLocalDateTimeString () {
    const now = new Date()
    const year = now.getFullYear()
    const month = String(now.getMonth() + 1).padStart(2, '0')
    const day = String(now.getDate()).padStart(2, '0')
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')
    return `${year}-${month}-${day}T${hours}:${minutes}`
  }

  export default {
    components: {
      PSwitch,
      ManagementSuppliersAdd,
      ManagementSeriesAdd
    },
    data () {
      return {
        totalValue: 0,
        selectedQuantity: '',
        selectedUnit: '',
        previousSelectedUnit: '',
        supplierSelected: null,
        selectedLocation: null,
        name: '',
        description: '',
        type: '',
        umProduct: null,
        currencyProduct: 'RON',
        code: '',
        tableData: [],
        gestiuniList: [],
        selectedGestiuneId: null,
        locations: [],
        nume: '',
        codeFiscalFurnizor: '',
        selectedLocationId: '',
        dataScadenta: '',
        nrDocument: '',
        currentNumber: '',
        isNir: false,
        isInvoiceSupplier: false,
        seriesNumber: '',
        vats: [],
        seriesOptions: [],
        dataDocument: getLocalDateTimeString(),
        vatNumberFurnizor: '',
        dataInStoc: getLocalDateTimeString(),
        tipDocument: 'factura',
        valoare: '',
        loading: false,
        currency: 'RON',
        precizie: '2 zecimale',
        selectedCategory: '',
        companyID: '',
        numeFurnizor: '',
        searchResults: [],
        editIndex: null,
        addItem: false,
        isEdit: !!this.route.params.id,
        invoiceSupplierId: null,
        supplierResults: [],
        fetchTimeout: null,
        modelValidate: {
          nume: { required: true },
          selectedGestiuneId: {required: true},
          codeFiscalFurnizor: { required: true },
          dataInStoc: { required: true },
          dataDocument: { required: true },
          tipDocument: { required: true },
          nrDocument: { required: true }
        },
        defaultGestiuneId: '',
        item: {
          nr: '',
          productName: '',
          productInvoiceSupplier: '',
          umInvoiceSupplier: '',
          quantityInvoiceSupplier: null,
          categoria: '',
          gestiune: '',
          um: '',
          cantitate: null,
          tva: '',
          pretFaraTva: null,
          price: null,
          adaosLinie: null,
          adaosProc: null,
          adaosTotal: null,
          tvaProdusVanzare: null,
          currency: 'RON',
          valoare: 'fara_tva',
          posId: ''
        },
        adaos: 0,
        adaosProc: 0,
        categories: [
          { value: 'Marfa', label: 'Marfa' },
          { value: 'Materii prime', label: 'Materii prime' },
          { value: 'Materiale consumabile', label: 'Materiale consumabile' },
          { value: 'Semifabricate (Reteta)', label: 'Semifabricate (Reteta)' },
          { value: 'Produs finit (Reteta)', label: 'Produs finit (Reteta)' },
          { value: 'Produs rezidual', label: 'Produs rezidual' },
          { value: 'Ambalaje', label: 'Ambalaje' },
          { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }
        ],
        productCategories: [
          { value: 'Marfa', label: 'Marfa' },
          { value: 'Materii prime', label: 'Materii prime' },
          { value: 'Materiale consumabile', label: 'Materiale consumabile' },
          { value: 'Produs rezidual', label: 'Produs rezidual' },
          { value: 'Ambalaje', label: 'Ambalaje' },
          { value: 'Obiecte de inventar', label: 'Obiecte de inventar' }
        ],
        mesurementsUnits: [],
        unit_calc: [],
        extraFields: {
          delegat: '',
          carteIdentitate: '',
          auto: '',
          notaInterna: ''
        }
      }
    },
    props: {
      route: {
        type: Object,
        default: () => ({})
      }
    },
    created () {
      this.companyID = this.$session.get('selectedCompany')

      const i = this.route && this.route.params && this.route.params.id

      function arrayToObject (arr) {
        const obj = {}
        arr.forEach(item => {
          obj[item.key] = item.value || ''
        })
        return obj
      }

      if (i) {
        swal({
          title: 'Se încarcă...',
          text: 'Așteaptă încărcarea datelor',
          allowOutsideClick: false,
          didOpen: () => {
            swal.showLoading()
          }
        })
        this.fetchNir(i).then(result => {
          const nir = result && result.nir
          if (!nir) {
            swal.close()
            return
          }

          this.nume = nir.nume_furnizor || ''
          this.codeFiscalFurnizor = nir.vatNumberFurnizor || ''

          const supplier = this.supplierResults.find(s => s.id === nir.supplierId) || {
            id: nir.supplierId || null,
            nume: nir.nume_furnizor,
            vatNumber: nir.vatNumberFurnizor
          }

          this.supplierSelected = supplier

          this.dataDocument = nir.data_document || ''
          this.dataInStoc = nir.data_in_stoc || ''
          this.dataScadenta = nir.data_scadentei || ''
          this.tipDocument = nir.tip_document || ''
          this.nrDocument = nir.numar_document || ''
          this.valoare = nir.valoare || ''
          this.currency = nir.moneda || 'RON'
          this.precizie = nir.precizie || '2 zecimale'
          this.vatNumber = nir.vatNumber || null

          this.invoiceSupplierId = nir.invoice_supplier || null

          this.seriesOptions = [{
            series: nir.series,
            currentNumber: nir.nirNumber
          }]
          this.seriesNumber = nir.series
          this.currentNumber = nir.nirNumber

          this.extraFields = arrayToObject(nir.extraFields || [])

          this.tableData = (nir.items || []).map((item, index) => {
            // Păstrează și cantități negative (nu filtra cu > 0)
            const cantitate = (item.cantitate != null && item.cantitate !== '')
              ? item.cantitate
              : (item.invoice_supplier_quantity != null && item.invoice_supplier_quantity !== ''
                ? item.invoice_supplier_quantity
                : null)
            const pretFaraTva = item.pret_fara_tva || 0
            const tva = item.tva_percent
            const valoareFaraTva = cantitate * pretFaraTva

            const valoareTva = item.valoare_tva != null
              ? item.valoare_tva
              : +(valoareFaraTva * (tva / 100)).toFixed(2)

            return {
              nr: item.cod,
              productName: item.denumire_produs_sau_serviciu || '',
              categoria: item.categoria,
              gestiune: item.gestiune || (this.gestiuniList.length ? this.gestiuniList[0].name : ''),
              um: item.u_m,
              cantitate,
              tva,
              pretFaraTva,
              currency: item.currency || 'RON',
              valoareCalculata: item.valoare_calculata || null,
              valoareTva,
              price: item.pretVanzare,
              posId: item.posId || '',
              adaosLinie: item.adaosLinie || null,
              adaosTotal: item.adaosTotal || null,
              adaosProc: item.adaosProc || null,
              salePriceFaraTva: item.salePriceFaraTva || null,
              tvaProdusVanzare: item.tvaProdusVanzare || null,
              categorie: item.categorie
            }
          })

          if (nir.externalLocationId) {
            this.selectedLocationId = nir.externalLocationId
          }

          if (nir.gestiune) {
            this.selectedGestiuneId = nir.gestiune || null
          }
          swal.close()
        }).catch(error => {
          console.error(error)
          swal.close()
        })
      }
      this.fetchLocation()
      this.fetchGestiuni()
      this.loadMesurementsUnits()
    },
    computed: {
      today () {
        const now = new Date()
        now.setSeconds(0, 0)
        return now.toISOString().slice(0, 16)
      },
      seriesOptionsWithAdd () {
        return [
          ...this.seriesOptions,
          { id: 'add', nume: '➕ Adaugă serie' }
        ]
      },
      groupedLocations () {
        const groups = {}

        if (!this.locations || !this.locations.length) return []

        this.locations.forEach(location => {
          const vat = location.inv_fiscal_code || 'Fără cod fiscal'

          if (this.isInvoiceSupplier && this.vatNumber && this.normalizeVat(vat) !== this.normalizeVat(this.vatNumber)) return

          if (!groups[vat]) {
            groups[vat] = []
          }
          groups[vat].push(location)
        })

        const result = Object.entries(groups).map(([vat, locations]) => ({
          vat,
          locations
        }))

        return result
      },
      filteredGestiuni () {
        if (!this.selectedLocation) return []

        return this.gestiuniList.filter(g =>
          g.externalLocationId === this.selectedLocation.true_id
        )
      },
      totalFaraTva () {
        // Calculăm totalul fără TVA, excluzând corecțiile
        return this.tableData.reduce((sum, row) => {
          if (row.nr !== 'Corectie') {
            return sum + (row.valoareCalculata || 0)
          }
          return sum
        }, 0)
      },
      totalTva () {
        // Calculăm TVA-ul, excluzând corecțiile
        return this.tableData.reduce((sum, row) => {
          if (row.nr !== 'Corectie') {
            return sum + (row.valoareTva || 0)
          }
          return sum
        }, 0)
      },
      totalCorectie () {
        // Calculăm corecțiile, adăugând corecțiile negative sau pozitive
        return this.tableData.reduce((sum, row) => {
          if (row.nr === 'Corectie') {
            // Dacă este corecție negativă, scădem valoarea din total
            if (row.productName === 'Corectie Negativa') {
              return sum - Math.abs(row.valoareCalculata || 0)
            }
            return sum + (row.valoareCalculata || 0) // Adăugăm corecția pozitivă
          }
          return sum
        }, 0)
      },
      totalFinal () {
        const totalCorectie = this.totalCorectie
        return this.totalFaraTva + this.totalTva + totalCorectie
      },
      totalPretVanzare () {
        return this.tableData.reduce((sum, row) => {
          if (row.nr !== 'Corectie' && row.price != null && row.cantitate != null) {
            return sum + row.price * row.cantitate
          }
          return sum
        }, 0)
      },
      valoareNir () {
        return this.tableData.reduce((sum, item) => {
          if (item.nr !== 'Corectie' && item.price != null && item.cantitate != null) {
            return sum + item.cantitate * item.price
          }
          return sum
        }, 0)
      },
      hasMarfaProducts () {
        return this.tableData.some(row => row.categoria === 'Marfa')
      }
    },
    watch: {
      locations: {
        handler (newLocations) {
          if (!newLocations || !newLocations.length) return

          // 1️⃣ La NIR din query
          const { series, number, isNir } = this.route && this.route.query
          this.isNir = (isNir === 'true' || isNir === true)
          if (this.isNir && series && number) {
            this.fetchOrder(series, number)
          }

          const { id, vatNumber, isInvoiceSupplier } = this.route && this.route.query
          this.isInvoiceSupplier = (isInvoiceSupplier === 'true' || isInvoiceSupplier === true)
          this.vatNumber = vatNumber || null

          if (this.isInvoiceSupplier && id) {
            this.fetchInvoiceSupplier(id, vatNumber)
          }

          // 2️⃣ Dacă suntem în edit și avem selectedLocationId
          if (this.isEdit && this.selectedLocationId) {
            const loc = this.groupedLocations
              .flatMap(group => group.locations)
              .find(l => l.true_id === this.selectedLocationId)

            if (loc) {
              this.selectedLocation = loc

              // Setăm gestiunea implicită dacă există
              if (!this.selectedGestiuneId && loc.gestiune_id_default) {
                const defaultGestiune = this.filteredGestiuni.find(
                  g => g._id === loc.gestiune_id_default
                )
                if (defaultGestiune) {
                  this.defaultGestiuneId = defaultGestiune._id
                  this.item.gestiune = defaultGestiune._id
                }
              }

              // Alte funcții dacă e nevoie
              if (!this.isEdit && loc.inv_fiscal_code) {
                this.getSeries(loc.inv_fiscal_code, loc.true_id)
              }
              this.loadVats(loc.true_id)
            }
          }
        },
        immediate: true
      },
      selectedLocationId (id) {
        console.log('Selected location ID changed to:', id)
        console.log('Grouped Locations:', this.groupedLocations)
        for (const group of this.groupedLocations) {
          const loc = group.locations.find(l => l.true_id === id)
          if (!loc) continue

          if (!this.isNir && !this.isEdit && !this.isInvoiceSupplier && this.tableData && this.tableData.length > 0) {
            swal({
              title: 'Atenție!',
              text: 'Ai produse adăugate. Pentru a putea schimba locația, te rog șterge mai întâi produsele existente.',
              type: 'warning',
              button: 'OK',
              dangerMode: true
            })

            this.$nextTick(() => {
              this.selectedLocationId = this.selectedLocation.true_id || null
            })
            return
          }

          // Aplică locația și gestiunea curentă normal
          this.selectedLocation = loc

          if (!this.isEdit && loc.inv_fiscal_code) {
            this.getSeries(loc.inv_fiscal_code, loc.true_id)
          }

          this.loadVats(loc.true_id)

          if (!this.selectedGestiuneId && loc.gestiune_id_default) {
            const defaultGestiune = this.filteredGestiuni.find(
              g => g._id === loc.gestiune_id_default
            )
            if (defaultGestiune) {
              this.defaultGestiuneId = defaultGestiune._id
              this.item.gestiune = defaultGestiune._id
            }
          }

          break
        }
      },
      totalFinal (newVal) {
        this.valoare = newVal.toFixed(2)
      },
      'selectedCategory' (newCategory, oldCategory) {
        if (!newCategory || newCategory !== oldCategory) {
          // Resetează toate câmpurile relevante
          this.item = {
            nr: '',
            gestiune: '',
            productName: '',
            categoria: '', // păstrează categoria selectată
            um: '',
            cantitate: null,
            tva: '',
            pretFaraTva: null,
            price: null,
            currency: 'RON',
            valoare: 'fara_tva',
            posId: ''
          }

          // Resetează lista de rezultate pentru v-select
          this.searchResults = []
        }
      },
      item: {
        handler () {
          this.calculateAdaos()
        },
        deep: true
      },
      selectedQuantity () {
        this.calculateAdaos()
      }
    },
    methods: {
      calculateUnitPrice () {
        if (this.totalValue && this.totalValue > 0 && this.selectedQuantity > 0) {
          this.item.pretFaraTva = this.totalValue / this.selectedQuantity
        }
      },
      normalizeVat (vat) {
        return String(vat || '').replace(/^ro/i, '').trim()
      },
      normalizeUm (um) {
        const raw = String(um || '').trim().toUpperCase()
        if (raw === 'GR' || raw === 'GRAME' || raw === 'GRAM') return 'G'
        if (raw === 'KG' || raw === 'KILOGRAM' || raw === 'KILOGRAME') return 'KG'
        if (raw === 'ML' || raw === 'MILILITRU' || raw === 'MILILITRI') return 'ML'
        if (raw === 'L' || raw === 'LITRU' || raw === 'LITRI') return 'L'
        return raw
      },
      // Mapare extinsă doar pentru SPV / e-Factura (nu afectează NIR normal)
      normalizeInvoiceUm (um) {
        const raw = String(um || '').trim().toUpperCase()
        if (!raw) return ''

        if (raw === '58' || raw === 'KGM' || raw === 'E4' || raw === 'MND') return 'KG'
        if (raw === 'GRM' || raw === 'GR' || raw === 'G') return 'G'
        if (raw === 'LTR' || raw === 'L') return 'L'
        if (raw === 'MLT' || raw === 'ML') return 'ML'
        if (raw === 'H87' || raw === 'BUC' || raw === 'C62') return 'BUC'

        if (raw.includes('KILOGRAM')) return 'KG'
        if (raw === 'GRAM' || raw.startsWith('GRAM ') || raw.endsWith(' GRAM') || raw === 'GRAME') return 'G'
        if (raw.includes('MILILITRU') || raw.includes('MILILITRI')) return 'ML'
        if (raw.includes('LITRU') || raw.includes('LITRI')) return 'L'

        return this.normalizeUm(um)
      },
      // Câte unități `toUm` în 1 unitate `fromUm` (ex: KG→G = 1000) — doar SPV
      getCompatibleUmRatio (fromUm, toUm) {
        const from = this.normalizeInvoiceUm(fromUm)
        const to = this.normalizeInvoiceUm(toUm)
        if (!from || !to || from === to) return 1

        const known = {
          'KG|G': 1000,
          'G|KG': 0.001,
          'L|ML': 1000,
          'ML|L': 0.001
        }
        return known[`${from}|${to}`] != null ? known[`${from}|${to}`] : null
      },
      getDocumentUmShort (unit = this.selectedUnit) {
        if (unit && typeof unit === 'object' && unit.short) return unit.short
        if (typeof unit === 'string' && unit) return unit
        return this.item.um || ''
      },
      getRowDocumentUmShort (row, unit = row.umDocument) {
        if (unit && typeof unit === 'object' && unit.short) return unit.short
        if (typeof unit === 'string' && unit) return unit
        return row.um || ''
      },
      resolveInvoiceUmCanonical (row) {
        const candidates = [row.umInvoiceSupplier]
        const invoiceText = this.getUnitText(row.umInvoiceSupplier)
        if (invoiceText) candidates.push(invoiceText)
        if (this.getUnitCodeFromText) {
          const mapped = this.getUnitCodeFromText(row.umInvoiceSupplier)
          if (mapped) candidates.push(mapped)
          if (invoiceText) {
            const mappedText = this.getUnitCodeFromText(invoiceText)
            if (mappedText) candidates.push(mappedText)
          }
        }

        for (const candidate of candidates) {
          const normalized = this.normalizeInvoiceUm(candidate)
          if (normalized === 'G' || normalized === 'KG' || normalized === 'ML' || normalized === 'L' || normalized === 'BUC') {
            return normalized
          }
        }

        return this.normalizeInvoiceUm(invoiceText || row.umInvoiceSupplier)
      },
      getRowUnitCalcObject (row, umShort) {
        if (!row || !umShort) return umShort
        if (row.um && this.normalizeUm(row.um) === this.normalizeUm(umShort)) return row.um

        const fromRowCalc = (row.unit_calc || []).find(u => this.normalizeUm(u.short) === this.normalizeUm(umShort))
        if (fromRowCalc) return fromRowCalc

        const fromMesurements = (this.mesurementsUnits || []).find(u => this.normalizeUm(u.short) === this.normalizeUm(umShort))
        return fromMesurements || umShort
      },
      getRowDocumentUmOptions (row) {
        const opts = []
        const add = (short) => {
          if (short && !opts.some(o => this.normalizeUm(o) === this.normalizeUm(short))) {
            opts.push(short)
          }
        }

        if (row.um) add(row.um)
        ;(row.unit_calc || []).forEach(unit => add(unit.short))
        ;(this.mesurementsUnits || []).forEach(unit => add(unit.short))

        return opts
      },
      matchInvoiceUmToRowOptions (row) {
        const options = this.getRowDocumentUmOptions(row)
        if (!options.length) return null

        const invoiceCanonical = this.resolveInvoiceUmCanonical(row)
        const candidates = [row.umInvoiceSupplier, invoiceCanonical]
        const invoiceText = this.getUnitText(row.umInvoiceSupplier)
        if (invoiceText) candidates.push(invoiceText)
        if (this.getUnitCodeFromText) {
          const mapped = this.getUnitCodeFromText(row.umInvoiceSupplier)
          if (mapped) candidates.push(mapped)
        }

        for (const candidate of candidates) {
          const match = options.find(opt =>
            this.normalizeUm(opt) === this.normalizeUm(candidate) ||
            this.normalizeUm(opt) === this.normalizeInvoiceUm(candidate)
          )
          if (match) return match
        }

        return null
      },
      resolveInvoiceRowDocumentUm (row) {
        const matched = this.matchInvoiceUmToRowOptions(row)
        if (matched) return matched
        const options = this.getRowDocumentUmOptions(row)
        return row.um || options[0] || row.umInvoiceSupplier || ''
      },
      // Câte unități produs (ex: G) în 1 unitate document (ex: KG). Ex: G←KG = 1000
      getRowBaseUnitsPerDocumentUnit (row, unit = row.umDocument) {
        const productUm = this.normalizeUm(row.um)
        const docUm = this.normalizeInvoiceUm(this.getRowDocumentUmShort(row, unit))
        if (!productUm || !docUm || productUm === docUm) return 1

        const ratio = this.getCompatibleUmRatio(docUm, productUm)
        if (ratio != null) return ratio

        const unitObj = this.getRowUnitCalcObject(row, unit)
        if (unitObj && typeof unitObj === 'object' && unitObj.value != null && Number(unitObj.value) > 0) {
          return 1 / Number(unitObj.value)
        }
        return 1
      },
      // Preț pe UM recepție, pornind de la prețul pe UM factură (fără a trece prin UM stoc)
      getPretPerDocumentUnit (row) {
        const pretInvoice = Number(row.pretInvoiceSupplier != null ? row.pretInvoiceSupplier : row.pretFaraTva) || 0
        if (!pretInvoice) return pretInvoice

        const invoiceUm = this.resolveInvoiceUmCanonical(row)
        const docUm = this.normalizeInvoiceUm(this.getRowDocumentUmShort(row, row.umDocument))
        if (!invoiceUm || !docUm || invoiceUm === docUm) return pretInvoice

        // câte unități factură în 1 unitate recepție (ex: 1 G = 0.001 KG)
        const invoiceUnitsPerDocUnit = this.getCompatibleUmRatio(docUm, invoiceUm)
        if (invoiceUnitsPerDocUnit == null) return pretInvoice
        return pretInvoice * invoiceUnitsPerDocUnit
      },
      // Preț pe UM factură, pornind de la prețul pe UM recepție
      getInvoicePriceFromDocumentUnit (row, pretDocument) {
        const pretDoc = Number(pretDocument) || 0
        if (!pretDoc) return pretDoc

        const invoiceUm = this.resolveInvoiceUmCanonical(row)
        const docUm = this.normalizeInvoiceUm(this.getRowDocumentUmShort(row, row.umDocument))
        if (!invoiceUm || !docUm || invoiceUm === docUm) return pretDoc

        const invoiceUnitsPerDocUnit = this.getCompatibleUmRatio(docUm, invoiceUm)
        if (invoiceUnitsPerDocUnit == null || !invoiceUnitsPerDocUnit) return pretDoc
        return pretDoc / invoiceUnitsPerDocUnit
      },
      applyInvoiceSupplierStockFromValue (row, qtyDoc, valoareFaraTva, pretDocument) {
        const vatRate = Number(row.tva) || 0
        row.valoareTva = parseFloat(((valoareFaraTva * vatRate) / 100).toFixed(2))

        if (row.um) {
          const mult = this.getRowBaseUnitsPerDocumentUnit(row)
          row.cantitate = parseFloat((qtyDoc * mult).toFixed(6))
          row.pretFaraTva = row.cantitate
            ? parseFloat((valoareFaraTva / row.cantitate).toFixed(6))
            : pretDocument
        } else {
          row.cantitate = qtyDoc
          row.pretFaraTva = pretDocument
        }
      },
      recalculateInvoiceSupplierRow (row) {
        if (!row) return

        const qtyDoc = Number(row.cantitateDocument)
        const valoareFaraTva = Number(row.valoareInvoiceSupplier) || Number(row.valoareCalculata) || 0

        // Valoarea totală rămâne fixă din SPV
        row.valoareCalculata = parseFloat(valoareFaraTva.toFixed(2))

        if (isNaN(qtyDoc) || qtyDoc <= 0) {
          row.cantitate = null
          return
        }

        // Preț unitar = valoare fixă / cantitate (în UM recepție curentă)
        const pretDocument = valoareFaraTva / qtyDoc
        row.pretInvoiceSupplier = parseFloat(pretDocument.toFixed(3))

        this.applyInvoiceSupplierStockFromValue(row, qtyDoc, valoareFaraTva, pretDocument)
      },
      // Câte unități produs (ex: G) în 1 unitate document (ex: KG). Ex: G←KG = 1000
      getBaseUnitsPerDocumentUnit (unit = this.selectedUnit) {
        const productUm = this.normalizeUm(this.item.um)
        const docUm = this.normalizeUm(this.getDocumentUmShort(unit))
        if (!productUm || !docUm || productUm === docUm) return 1

        const known = {
          'G|KG': 1000,
          'KG|G': 0.001,
          'ML|L': 1000,
          'L|ML': 0.001
        }
        const key = `${productUm}|${docUm}`
        if (known[key] != null) return known[key]

        // fallback unit_calc: selectedQty = baseQty * value ⇒ basePerDoc = 1/value
        if (unit && typeof unit === 'object' && unit.value != null && Number(unit.value) > 0) {
          return 1 / Number(unit.value)
        }
        return 1
      },
      getDefaultUnitCalc (productUm) {
        const um = this.normalizeUm(productUm)
        const defaults = {
          G: [{ short: 'KG', value: 0.001, name: 'Kilogram' }],
          KG: [{ short: 'G', value: 1000, name: 'Gram' }],
          ML: [{ short: 'L', value: 0.001, name: 'Litru' }],
          L: [{ short: 'ML', value: 1000, name: 'Mililitru' }]
        }
        return defaults[um] ? defaults[um].map(u => ({ ...u })) : []
      },
      mergeUnitCalc (configured, productUm) {
        // Pentru G/KG/ML/L forțăm factorii corecți (ignorăm value greșit din nomenclator)
        const byShort = {}
        this.getDefaultUnitCalc(productUm).forEach(def => {
          byShort[String(def.short).toUpperCase()] = { ...def }
        })
        ;(Array.isArray(configured) ? configured : []).forEach(unit => {
          const short = String(unit.short || '').toUpperCase()
          if (!short || byShort[short]) return
          byShort[short] = unit
        })
        return Object.keys(byShort).map(k => byShort[k])
      },
      // pret pe UM document → pret pe UM produs (fără a modifica inputul din UI)
      convertPriceToProductUm (pricePerDocumentUnit, unit = this.selectedUnit) {
        const mult = this.getBaseUnitsPerDocumentUnit(unit)
        return mult ? Number(pricePerDocumentUnit) / mult : Number(pricePerDocumentUnit)
      },
      checkGestiuneChange (event) {
        if (!this.isEdit && !this.isInvoiceSupplier && this.tableData && this.tableData.length > 0) {
          // previne schimbarea imediată
          event.preventDefault()

          swal({
            title: 'Atentie!',
            text: 'Ai produse adaugate cu pret de vanzare pe aceasta gestiune. Doresti stergerea produselor?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Da, șterge-l!',
            cancelButtonText: 'Anulează'
          }).then((result) => {
            if (result) {
              this.tableData.splice(0, this.tableData.length)
              // Permitem schimbarea gestiunii
              this.selectedGestiuneId = event.target.value
            } else {
              // Dacă nu confirmă, nu facem nimic
            }
          })
        }
      },
      calculateAdaos (item = null) {
        const prod = item || this.item
        const price = Number(prod.price) || 0
        const pretRaw = Number(prod.pretFaraTva) || 0
        // în modal pretul e pe UM document; pe rândurile salvate e deja pe UM produs
        const isModalItem = !item || item === this.item
        const pretAchizitie = isModalItem ? this.convertPriceToProductUm(pretRaw) : pretRaw
        const cantitate = Number(prod.cantitate || (isModalItem ? this.selectedQuantity : 1) || 1)
        const vatPercent = Number(prod.tva || 0)
        const isCuTva = prod.valoare === 'cu_tva'

        let salePriceFaraTva = 0
        let adaosLinie = 0
        let adaosTotal = 0
        let adaosProc = 0

        if (prod.categoria === 'Marfa' && price > 0 && pretAchizitie > 0) {
          // scoatem TVA dacă prețul este cu TVA
          salePriceFaraTva = isCuTva ? price / (1 + vatPercent / 100) : price

          adaosLinie = salePriceFaraTva - pretAchizitie
          adaosTotal = adaosLinie * cantitate
          adaosProc = pretAchizitie > 0 ? (adaosLinie / pretAchizitie) * 100 : 0
        }

        // actualizăm itemul
        prod.adaosLinie = adaosLinie
        prod.adaosTotal = adaosTotal
        prod.adaosProc = adaosProc
        this.salePriceFaraTva = salePriceFaraTva

        return { adaosLinie, adaosTotal, adaosProc, salePriceFaraTva }
      },
      async loadMesurementsUnits () {
        this.mesurementsUnits = await this.getMesurementsUnits()
        this.normalizeInvoiceSupplierRowsUm()
      },
      normalizeInvoiceSupplierRowsUm () {
        if (!this.isInvoiceSupplier || !this.tableData.length) return

        this.tableData.forEach(row => {
          const resolved = this.resolveInvoiceRowDocumentUm(row)
          if (resolved && resolved !== row.umDocument) {
            this.$set(row, 'umDocument', resolved)
          }
          if (row.um || row.pretInvoiceSupplier != null) {
            this.recalculateInvoiceSupplierRow(row)
          }
        })
      },
      async loadVats (locationId) {
        console.log('Loading VATs for location:', locationId)
        this.vats = await this.fetchVats(locationId)
      },
      onInputQuantity (event) {
        const qtyDoc = Number(this.selectedQuantity)
        if (!isNaN(qtyDoc)) {
          const mult = this.getBaseUnitsPerDocumentUnit()
          this.item.cantitate = parseFloat((qtyDoc * mult).toFixed(6))
        } else {
          this.item.cantitate = this.selectedQuantity
        }

        this.calculateUnitPrice()
      },
      onInputNumber (event) {
        if (this.item.pretFaraTva < 0) {
          this.item.pretFaraTva = 0
        }
      },
      getGestiuneNameById (id) {
        const gest = this.filteredGestiuni.find(g => g._id === id)
        return gest ? gest.name : id
      },
      validate () {
        this.$validator.validateAll().then(isValid => {
          if (isValid) { this.saveNIR() }
        })
      },
      getEmptyItem () {
        this.selectedQuantity = ''
        this.selectedUnit = ''
        this.previousSelectedUnit = ''
        this.totalValue = 0
        this.unit_calc = []
        return {
          nr: '',
          productName: '',
          categoria: '',
          gestiune: '',
          um: '',
          cantitate: null,
          tva: '',
          pretFaraTva: null,
          price: null,
          currency: 'RON',
          valoare: 'fara_tva',
          posId: '',
          selectedCategory: ''
        }
      },
      updateNumber () {
        if (this.seriesNumber === 'add') {
          this.openSeriesModal()
          return
        }

        const selectedSeries = this.seriesOptions.find(
          (series) => series.series === this.seriesNumber
        )

        if (selectedSeries) {
          this.currentNumber = selectedSeries.currentNumber
        } else {
          this.currentNumber = ''
        }
      },
      openSeriesModal () {
        this.$modal.show('addSeriesModal')
      },
      async fetchLocation () {
        const dataToSend = {
          company_id: this.companyID,
          token: this.$session.get('token')
        }

        this.apiRequest('/gestiune/locations', 'GET', dataToSend, (response) => {
          if (!response || response.status !== true || !response.data || !response.data.locations) {
            swal({
              title: 'Eroare!',
              text: response.message || 'Eroare la preluarea locațiilor.',
              type: 'error',
              timer: 3000,
              showConfirmButton: false
            })
            return
          }

          this.locations = response.data.locations
        })
      },
      async getSeries (vatNumber, externalLocationId = null) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/getSeries`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              externalCompanyId: this.companyID,
              vatNumber: vatNumber,
              tip: 'nir'
            })
          })

          if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`)

          const data = await response.json()

          if (Array.isArray(data.series) && data.series.length > 0) {
            let seriesList = data.series

            // Filtrare după externalLocationId dacă există
            if (externalLocationId) {
              const filtered = seriesList.filter(serie => serie.externalLocationId === externalLocationId)

              // dacă nu există serii cu acel externalLocationId, păstrează toate
              if (filtered.length > 0) {
                seriesList = filtered
              }
            }

            this.seriesOptions = seriesList.map(serie => ({
              series: serie.series,
              currentNumber: serie.currentNumber,
              externalLocationId: serie.externalLocationId || null
            }))

            this.seriesNumber = this.seriesOptions[0].series
            this.currentNumber = this.seriesOptions[0].currentNumber
          } else {
            console.warn('Nu există serii disponibile pentru acest cod fiscal.')
            this.seriesOptions = []
            this.seriesNumber = ''
            this.currentNumber = ''
          }
        } catch (error) {
          console.error('Error fetching series:', error)
          this.seriesOptions = []
          this.seriesNumber = ''
          this.currentNumber = ''
        }
      },
      async fetchOrder (series, number) {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order?series=${series}&number=${number}&externalCompanyId=${this.companyID}`)
          if (!response.ok) {
            throw new Error(`Eroare la fetch order: ${response.status}`)
          }

          const data = await response.json()

          if (data) {
            this.myOrder = {
              ...data
            }

            if (data.supplierExternalLocationId) {
              this.selectedLocationId = data.supplierExternalLocationId
            }

            if (data.supplierExternalLocationId && this.locations && this.locations.length) {
              const foundLocation = this.locations.find(loc => loc.true_id === data.supplierExternalLocationId)
              if (foundLocation) {
                this.nume = foundLocation.inv_company_name || ''
                this.codeFiscalFurnizor = foundLocation.inv_fiscal_code || ''
              }
            }

            if (data.externalDocIds && data.externalDocIds.aviz) {
              const { number } = data.externalDocIds.aviz
              this.nrDocument = `${number}`
              this.tipDocument = 'aviz'
            }

            this.tableData = data.products.map((item, index) => {
              // Dacă quantity poate fi 0, folosește ?? în loc de ||
              const quantity = (item.quantity_faptic !== null && item.quantity_faptic !== undefined)
                ? item.quantity_faptic
                : (item.quantity_scriptic !== null && item.quantity_scriptic !== undefined)
                  ? item.quantity_scriptic
                  : 0
              const priceFaraTVA = item.pret_fara_tva || 0
              const vatRate = item.tva_percent != null ? item.tva_percent : ''
              const tvaValoareUnit = (priceFaraTVA * vatRate) / 100
              const valoareCalculata = parseFloat((priceFaraTVA * quantity).toFixed(2))
              const valoareTva = parseFloat((tvaValoareUnit * quantity).toFixed(2))

              return {
                nr: index + 1,
                productName: item.productName || '',
                categoria: item.categoria,
                gestiune: item.gestiune || this.myOrder.gestiune,
                um: item.unitMeasure,
                cantitate: quantity,
                tva: vatRate,
                pretFaraTva: priceFaraTVA,
                currency: item.currency || 'RON',
                valoareCalculata,
                valoareTva,
                posId: item.posId || ''
              }
            })

            this.valoare = this.totalFinal
          } else {
            console.error('Comandă invalidă primită:', data)
            swal({
              title: 'Eroare',
              text: 'Comanda nu a fost găsită.',
              type: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          console.error('Eroare la fetch order:', error)
          swal({
            title: 'Eroare',
            text: 'A apărut o problemă la încărcarea comenzii.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      async fetchInvoiceSupplier (id) {
        try {
          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/purchase/${id}?externalCompanyId=${this.companyID}`,
            { method: 'GET' }
          )

          if (!response.ok) throw new Error(`HTTP ${response.status}`)
          const result = await response.json()

          this.nrDocument = result.invoiceNumber
          this.invoiceSupplierId = result._id || id || null

          if (result.supplier) {
            this.nume = result.supplier.name || ''
            this.codeFiscalFurnizor = result.supplier.vat || ''

            // 🔹 căutăm supplier-ul în lista deja încărcată
            const existingSupplier = this.supplierResults.find(
              s => s.vatNumber === result.supplier.vat
            )

            if (existingSupplier) {
              this.supplierSelected = existingSupplier
            } else {
              // dacă nu există în listă, îl adăugăm manual
              const newSupplier = {
                id: result.supplier.id || result.supplier.vat,
                nume: result.supplier.name,
                vatNumber: result.supplier.vat
              }

              this.supplierResults.push(newSupplier)
              this.supplierSelected = newSupplier
            }
          }

          this.tableData = result.items.map(function (item, index) {
            var quantity = 0
            var unitMeasure = ''
            var priceFaraTVA = 0
            var currency = 'RON'

            if (item.quantity && item.quantity.value != null) {
              quantity = item.quantity.value
            }
            if (item.quantity && item.quantity.unit) {
              unitMeasure = item.quantity.unit
            }
            if (item.price && item.price.value != null) {
              priceFaraTVA = item.price.value
            }
            if (item.price && item.price.currency) {
              currency = item.price.currency
            }

            var vatRate = (item.taxRate != null) ? item.taxRate : 0
            var tvaValoareUnit = (priceFaraTVA * vatRate) / 100
            var valoareCalculata = parseFloat((priceFaraTVA * quantity).toFixed(2))
            var valoareTva = parseFloat((tvaValoareUnit * quantity).toFixed(2))

            return {
              nr: index + 1,
              productInvoiceSupplier: item.name || '',
              categoria: item.categoria || '',
              gestiune: item.gestiune || '',
              umInvoiceSupplier: unitMeasure,
              quantityInvoiceSupplier: quantity,
              priceInvoiceSupplier: priceFaraTVA,
              valoareInvoiceSupplier: valoareCalculata,
              umDocument: unitMeasure,
              cantitateDocument: quantity > 0 ? quantity : null,
              unit_calc: [],
              pretInvoiceSupplier: priceFaraTVA,
              cantitate: null,
              tva: vatRate,
              pretFaraTva: priceFaraTVA,
              currency: currency,
              valoareCalculata: valoareCalculata,
              valoareTva: valoareTva,
              posId: item.posId || ''
            }
          })

          this.normalizeInvoiceSupplierRowsUm()

          console.log('Invoice supplier data received:', result)
        } catch (error) {
          console.error('❌ Eroare la fetch bon fiscal by ID:', error)
        }
      },
      async fetchNir (id) {
        try {
          const nirData = {
            externalCompanyId: this.companyID,
            nirNumber: this.route.query.nirNumber,
            data_document: this.route.query.data_document,
            vatNumberFurnizor: this.route.query.vatNumberFurnizor,
            series: this.route.query.series
          }

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/nir`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(nirData)
          })

          if (!response.ok) throw new Error('Failed to fetch or create NIR')

          const result = await response.json()
          return result
        } catch (error) {
          console.error('Error fetching NIR:', error)
        }
      },
      async fetchGestiuni () {
        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/gestiuni?externalCompanyId=${this.companyID}`)
          const data = await response.json()

          if (data && data.gestiuni && Array.isArray(data.gestiuni)) {
            this.gestiuniList = data.gestiuni
          } else {
            swal({
              title: 'Error!',
              text: 'Nu s-a primit un array valid de la server.',
              icon: 'error',
              timer: 2000,
              showConfirmButton: false
            })
          }
        } catch (error) {
          swal({
            title: 'Error!',
            text: `Request failed: ${error.message}`,
            icon: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          console.error('Error fetching management data:', error)
        }
      },
      async fetchProducts (searchTerm) {
        if (!this.selectedLocation || !searchTerm || searchTerm.length < 2) {
          this.searchResults = []
          return
        }

        // curăță debounce-ul anterior
        clearTimeout(this.fetchTimeout)

        // setează un debounce de 300ms (poți ajusta)
        this.fetchTimeout = setTimeout(async () => {
          this.loading = true

          try {
            let categorieParam = ''
            if (this.selectedCategory) {
              categorieParam = `&categorie=${encodeURIComponent(this.selectedCategory)}`
            } else {
              const allCategories = this.productCategories.map(c => c.value).join(',')
              categorieParam = `&categorie=${encodeURIComponent(allCategories)}`
            }

            const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/products?externalCompanyId=${this.companyID}&vatNumber=${this.selectedLocation.inv_fiscal_code}&name=${searchTerm}${categorieParam}`)
            const data = await response.json()

            if (Array.isArray(data.products)) {
              this.searchResults = [
                ...data.products,
                { id: 'add', name: '➕ Adaugă produs' }
              ]
            } else {
              this.searchResults = [
                { id: 'add', name: '➕ Adaugă produs' }
              ]
            }
          } catch (error) {
            console.error('Error fetching products:', error)
            this.searchResults = [
              { id: 'add', name: '➕ Adaugă produs' }
            ]
          } finally {
            this.loading = false
          }
        }, 300) // debounce-ul de 300ms
      },
      async fetchSuppliers (query) {
        const vatNumber = this.selectedLocation && this.selectedLocation.inv_fiscal_code

        this.loading = true
        try {
          const url = `${process.env.API_BASE_URL_GESTIUNE}:4443/suppliers` +
            `?name=${encodeURIComponent(query)}` +
            `&externalCompanyId=${this.companyID}` +
            (vatNumber ? `&vatNumber=${encodeURIComponent(vatNumber)}` : '')

          const response = await fetch(url)
          const data = await response.json()

          if (Array.isArray(data.suppliers)) {
            this.supplierResults = [
              ...data.suppliers.map(supplier => ({
                id: supplier._id,
                nume: supplier.name,
                vatNumber: supplier.vatNumber,
                fullData: supplier
              })),
              { id: 'add', nume: '➕ Adaugă furnizor' }
            ]
          } else {
            this.supplierResults = [
              { id: 'add', nume: '➕ Adaugă furnizor' }
            ]
          }
        } catch (error) {
          console.error('Error fetching suppliers:', error)
          this.supplierResults = [
            { id: 'add', nume: '➕ Adaugă furnizor' }
          ]
        } finally {
          this.loading = false
        }
      },
      resetProduct (row) {
        if (!row) return

        row.productName = ''
        row.posId = ''
        row.categoria = ''
        row.searchResults = []

        if (this.item && this.item.posId === row.posId) {
          this.item.productName = ''
          this.item.posId = ''
          this.item.categoria = ''
        }
      },
      onSupplierSelect (supplier) {
        if (supplier && supplier.id === 'add') {
          this.openAddSupplierModal()
          this.supplierSelected = null
          this.nume = ''
          this.codeFiscalFurnizor = ''
        } else if (supplier) {
          this.supplierSelected = supplier
          this.nume = supplier.nume || ''
          this.codeFiscalFurnizor = supplier.vatNumber || ''
        } else {
          this.supplierSelected = null
          this.nume = ''
          this.codeFiscalFurnizor = ''
        }
      },
      openAddSupplierModal () {
        this.supplier = {
          companyName: '',
          abbreviation: '',
          CUI: '',
          email: '',
          registrationNumber: '',
          address: '',
          bank: '',
          IBAN: '',
          dueDays: null,
          id: null,
          _rev: null
        }
        this.$modal.show('addSupplierModal')
      },
      convertUnit (previousUnit) {
        // Doar cantitatea (același stoc fizic); prețul de achiziție NU se modifică în UI
        const qtyDocOld = Number(this.selectedQuantity)
        const oldMult = this.getBaseUnitsPerDocumentUnit(previousUnit)
        const newMult = this.getBaseUnitsPerDocumentUnit(this.selectedUnit)

        let baseQty = Number(this.item.cantitate)
        if ((isNaN(baseQty) || baseQty === 0) && !isNaN(qtyDocOld) && qtyDocOld !== 0) {
          baseQty = qtyDocOld * oldMult
        }

        if (!isNaN(baseQty) && baseQty !== 0) {
          this.item.cantitate = parseFloat(baseQty.toFixed(6))
          this.selectedQuantity = parseFloat((baseQty / newMult).toFixed(6))
        }

        this.calculateAdaos()
      },
      onDocumentUnitChange () {
        this.convertUnit(this.previousSelectedUnit)
        this.previousSelectedUnit = this.selectedUnit
      },
      onProductSelect (selectedProduct, row) {
        if (!selectedProduct) return
        row = row || {}

        if (this.isInvoiceSupplier && !selectedProduct) {
          this.resetProduct(row)
          return
        }

        // Butonul "add"
        if (selectedProduct.id === 'add') {
          this.addProduct()
          return
        }

        // 🔹 Caz Invoice Supplier
        if (this.isInvoiceSupplier) {
          this.item.productName = selectedProduct.name || ''
          this.item.posId = selectedProduct.id || selectedProduct._id
          row.nr = selectedProduct.product_code || row.nr || ''
          row.productName = selectedProduct

          // setează categoria doar dacă nu e deja setată
          if (!this.item.categoria && selectedProduct.categorie) {
            let categoria = selectedProduct.categorie
              .trim()
              .replace(/\s+/g, ' ')
            const categorieMap = {
              'marfa': 'Marfa',
              'materii prime': 'Materii prime',
              'materiale consumabile': 'Materiale consumabile',
              'produs rezidual': 'Produs rezidual',
              'ambalaje': 'Ambalaje',
              'obiecte de inventar': 'Obiecte de inventar'
            }
            const normalizedKey = categoria.toLowerCase()
            this.item.categoria = categorieMap[normalizedKey] || categoria
          }

          if (selectedProduct.um) {
            row.um = selectedProduct.um
            this.item.um = selectedProduct.um
          }

          const unit = (this.mesurementsUnits || []).find(u =>
            this.normalizeUm(u.short) === this.normalizeUm(selectedProduct.um)
          )
          this.$set(row, 'unit_calc', this.mergeUnitCalc(unit ? unit.unit_calc : [], selectedProduct.um))

          if (row.cantitateDocument == null || row.cantitateDocument === '') {
            row.cantitateDocument = row.quantityInvoiceSupplier
          }

          const resolvedUm = this.resolveInvoiceRowDocumentUm(row)
          this.$set(row, 'umDocument', resolvedUm)
          this.$set(row, '_prevUmDocument', resolvedUm)
          this.recalculateInvoiceSupplierRow(row)
          this.syncRowToItem(row, this.item)

          return
        }

        if (selectedProduct && selectedProduct.id === 'add') {
          this.addProduct()
        } else if (selectedProduct) {
          console.log('selectedProduct', selectedProduct)
          this.item.nr = selectedProduct.product_code || ''
          this.item.posId = selectedProduct.posId || selectedProduct._id

          this.selectedUnit = selectedProduct.um
          this.previousSelectedUnit = selectedProduct.um
          this.item.um = selectedProduct.um
          this.item.tvaProdusVanzare = selectedProduct.vat_percent != null ? selectedProduct.vat_percent : ''

          const hasVat = selectedProduct.vat_percent != null && selectedProduct.vat_percent !== ''
          if (this.addItem) {
            if (hasVat) {
              this.item.valoare = 'cu_tva'
              this.item.tva = Number(selectedProduct.vat_percent)
            } else {
              this.item.tva = ''
            }
          } else if (this.item.tva === '' || this.item.tva === null || this.item.tva === undefined) {
            this.item.tva = hasVat ? Number(selectedProduct.vat_percent) : ''
          }

          if (this.selectedGestiuneId && selectedProduct.prices) {
            this.item.price = selectedProduct.prices[this.selectedGestiuneId] || selectedProduct.price || ''
          } else {
            this.item.price = selectedProduct.price || ''
          }

          let unit = (this.mesurementsUnits || []).find(u =>
            this.normalizeUm(u.short) === this.normalizeUm(selectedProduct.um)
          )
          this.unit_calc = this.mergeUnitCalc(unit ? unit.unit_calc : [], selectedProduct.um)

          // setează categoria doar dacă nu e deja setată
          if (!this.item.categoria && selectedProduct.categorie) {
            let categoria = selectedProduct.categorie
              .trim()
              .replace(/\s+/g, ' ')
            const categorieMap = {
              'marfa': 'Marfa',
              'materii prime': 'Materii prime',
              'materiale consumabile': 'Materiale consumabile',
              'produs rezidual': 'Produs rezidual',
              'ambalaje': 'Ambalaje',
              'obiecte de inventar': 'Obiecte de inventar'
            }

            const normalizedKey = categoria.toLowerCase()
            this.item.categoria = categorieMap[normalizedKey] || categoria
          }

          if (!this.selectedGestiuneId) {
            // nu există gestiune pe document → facem compatibilitate după categorie
            if (this.item.categoria) {
              const gestiuneCompatibila = this.filteredGestiuni.find(g =>
                g.categorie &&
                g.categorie.toLowerCase() === this.item.categoria.toLowerCase()
              )

              // setează item.gestiune (v-model-ul dropdown-ului)
              this.item.gestiune = gestiuneCompatibila ? gestiuneCompatibila._id : ''
            }
          } else {
            // există gestiune pe document → folosim doar gestiunea selectată
            this.item.gestiune = this.selectedGestiuneId
          }
        }
      },
      syncRowToItem (row, item) {
        if (!row || !item) return

        row.posId = item.posId || ''
        row.categoria = item.categoria || row.categoria || ''
      },
      isInvoiceSupplierRowMapped (row) {
        if (!row) return false
        if (row.nr === 'Corectie') return true

        const hasPosId = !!(row.posId)
        const hasUm = !!(row.um)
        const name = row.productName
        const hasProductName = !!(
          name && (
            typeof name === 'object'
              ? (name._id || name.id || name.name || name.posId)
              : String(name).trim()
          )
        )

        return hasPosId || (hasUm && hasProductName)
      },
      onInvoiceSupplierUnitChange (row) {
        const prevUm = row._prevUmDocument || row.umDocument
        const newUm = row.umDocument

        const ratioOldToNew = this.getCompatibleUmRatio(
          this.normalizeInvoiceUm(prevUm),
          this.normalizeInvoiceUm(newUm)
        ) || 1

        const oldQty = Number(row.cantitateDocument)

        if (oldQty > 0) {
          const newQty = parseFloat((oldQty * ratioOldToNew).toFixed(6))
          this.$set(row, 'cantitateDocument', newQty)
        }

        this.$set(row, '_prevUmDocument', newUm)
        this.recalculateInvoiceSupplierRow(row)
      },
      onInvoiceSupplierQuantityInput (row) {
        this.recalculateInvoiceSupplierRow(row)
      },
      addProduct () {
        this.$modal.show('addProduct')
      },
      closeProduct () {
        this.$modal.hide('addProduct')
      },
      async checkValidatedAfter (field, products = null) {
        try {
          const selectedDate = this[field]
          if (!selectedDate) return false

          if (!products) {
            if (!this.tableData || this.tableData.length === 0) {
              products = []
            } else {
              products = this.tableData.map(item => item.posId)
            }
          }

          const queryParams = new URLSearchParams({
            date: new Date(selectedDate).toISOString(),
            externalCompanyId: this.companyID,
            externalLocationId: this.selectedLocationId
          })

          const body = products.length > 0 ? { products } : null

          const response = await fetch(
            `${process.env.API_BASE_URL_GESTIUNE}:4443/inventar/validated-after-products?${queryParams.toString()}`,
            {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: body ? JSON.stringify(body) : null
            }
          )

          if (!response.ok) throw new Error(`Request failed: ${response.status}`)

          const data = await response.json()
          console.log('Response from validated-after:', data)

          if (data.exists) {
            await swal({
              icon: 'warning',
              title: 'Atenție!',
              text: 'Există deja un inventar validat după această dată pentru unul sau mai multe produse selectate.'
            })
            this[field] = null
            return false
          }

          return true
        } catch (err) {
          console.error(err)
          swal({
            icon: 'error',
            title: 'Eroare!',
            text: 'Nu s-a putut verifica inventarul.'
          })
          return false
        }
      },
      async addProductApi () {
        if (!this.name || !this.code || !this.type) {
          swal({
            title: 'Eroare',
            text: 'Toate câmpurile obligatorii trebuie completate!',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
          return
        }

        const productData = {
          name: this.name,
          product_code: this.code,
          is_with_vat: true,
          vat_percent: 20,
          currency: this.currencyProduct,
          um: this.umProduct,
          externalId: '',
          is_external: 0,
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocation.true_id,
          vatNumber: this.selectedLocation.inv_fiscal_code,
          categorie: this.type,
          pret_vanzare: []
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/nomenclator`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(productData)
          })

          const data = await response.json()

          if (!response.ok) {
            swal({
              title: 'Eroare',
              text: data.details || 'A apărut o eroare la salvarea produsului.',
              type: 'error',
              timer: 4000,
              showConfirmButton: false
            })
            return
          }

          // succes
          await this.fetchProducts()

          this.searchResults.push(data)
          this.productNameRecipe = data
          this.codeProductRecipe = data.product_code
          this.umRecipe = data.um
          this.posId = data._id

          swal({
            title: 'Succes',
            text: 'Produsul a fost salvat cu succes.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.$modal.hide('addProduct')
          this.resetFields()
        } catch (error) {
          console.error('Error saving product:', error)
          swal({
            title: 'Eroare',
            text: 'A apărut o eroare la salvarea produsului.',
            type: 'error',
            timer: 2000,
            showConfirmButton: false
          })
        }
      },
      resetFields () {
        this.name = ''
        this.description = ''
        this.code = ''
      },
      async saveProduct () {
        const missingFields = []

        if (!this.item.productName) missingFields.push('Produsul nu a fost selectat')
        if (!this.item.nr) missingFields.push('Numărul lipsește')
        if (!this.item.cantitate) missingFields.push('Cantitatea lipsește')
        if (!this.item.pretFaraTva) missingFields.push('Prețul lipsește')
        if (!this.item.um) missingFields.push('Unitatea de măsură lipsește')
        if (!this.item.gestiune) missingFields.push('Gestiunea lipsește')

        if (missingFields.length > 0) {
          swal({
            title: 'Eroare',
            html: missingFields.map(f => `• ${f}`).join('<br>'),
            type: 'error',
            timer: 4000,
            showConfirmButton: false
          })
          return
        }

        const productId = typeof this.item.productName === 'object'
        ? this.item.productName._id
        : this.item.productName

        const isValid = await this.checkValidatedAfter('dataInStoc', [productId])
        if (!isValid) return

        const tva = parseFloat(this.item.tva)
        const qtyDocument = Number(this.selectedQuantity)
        const mult = this.getBaseUnitsPerDocumentUnit()
        const cantitateCorecta = parseFloat((qtyDocument * mult).toFixed(6))
        this.item.cantitate = cantitateCorecta
        const pretIntrodus = parseFloat(this.item.pretFaraTva)

        // ⚠️ NU rotunji aici!
        // Prețul din UI rămâne pe UM document; valoarea = pret × cantitate document
        let pretDocument = pretIntrodus
        if (this.item.valoare === 'cu_tva') {
          pretDocument = pretIntrodus / (1 + tva / 100)
        }

        const valoareFaraTvaRaw = pretDocument * qtyDocument
        // pret stocat pe UM produs (ex: 25.5 RON/kg → 0.0255 RON/g)
        const pretFaraTva = cantitateCorecta
          ? (valoareFaraTvaRaw / cantitateCorecta)
          : this.convertPriceToProductUm(pretDocument)

        const valoareTvaRaw = valoareFaraTvaRaw * (tva / 100)
        const valoareCalculata = valoareFaraTvaRaw
        const valoareTva = valoareTvaRaw

        // Dacă productName e obiect, extrage numele și _id
        if (typeof this.item.productName === 'object') {
          this.item.productName = this.item.productName.name || this.item.productName.product_code
        }

        const gestiuneId = this.item.gestiune
        const umDocument = this.getDocumentUmShort()

        const itemToSave = {
          ...this.item,
          gestiune: gestiuneId,
          pretFaraTva,
          pretIntrodus,
          umDocument,
          cantitateDocument: qtyDocument || cantitateCorecta,
          valoareCalculata,
          valoareTva
        }

        if (this.editIndex !== null) {
          this.$set(this.tableData, this.editIndex, itemToSave)
        } else {
          this.tableData.push(itemToSave)
        }


        this.editIndex = null
        this.item = this.getEmptyItem()
        this.$modal.hide('addProductModal')
      },
      async saveNIR () {
        if (this.isInvoiceSupplier) {
          const mappedRows = this.tableData.filter(p => this.isInvoiceSupplierRowMapped(p))
          const invalidQty = mappedRows.filter(p =>
            p.nr !== 'Corectie' && (!p.cantitate || p.cantitate <= 0)
          )
          if (invalidQty.length > 0) {
            swal({
              title: 'Eroare',
              text: 'Cantitatea este obligatorie și trebuie să fie mai mare decât 0 pentru produsele mapate.',
              type: 'error',
              timer: 4000,
              showConfirmButton: false
            })
            return
          }
        }

        const valoareIntrodusa = parseFloat(this.valoare)
        const totalCalculat = parseFloat(this.totalFinal.toFixed(2))
        let diferenta = parseFloat((valoareIntrodusa - totalCalculat).toFixed(2))

        const existaAjustare = this.tableData.some(p => p.nr === 'Corectie')

        // Dacă diferența este semnificativă și nu am adăugat încă ajustarea
        if (Math.abs(diferenta) > 0.01 && !existaAjustare) {
          // const tvaDefault = 19
          // const valoareFaraTva = parseFloat((Math.abs(diferenta) / (1 + tvaDefault / 100)).toFixed(2))

          const ajustareItem = {
            productName: diferenta < 0 ? 'Corectie Negativa' : 'Corectie Pozitiva',
            nr: 'Corectie',
            categoria: 'Ajustare',
            um: 'buc',
            cantitate: 1,
            valoareCalculata: diferenta,
            gestiune: (this.tableData.length > 0 && this.tableData[0].gestiune) || '',
            posId: null
          }

          await swal({
            title: 'Corecție factură',
            text: `Diferența între totalul documentului și totalul calculat este de ${diferenta.toFixed(2)}. Se va adăuga automat un produs pentru ajustare.`,
            type: 'info',
            confirmButtonText: 'OK'
          })

          this.tableData.push(ajustareItem)

          return
        }

        const sourceRows = this.isInvoiceSupplier
          ? this.tableData.filter(p => this.isInvoiceSupplierRowMapped(p))
          : this.tableData

        const itemsWithAdaos = sourceRows.map(product => {
          // calculăm adaosul pentru fiecare item
          const adaos = this.calculateAdaos(product)

          const finalProduct = {
            ...product,
            ...adaos
          }

          return finalProduct
        })

        const nirData = {
          ...(this.selectedGestiuneId ? { gestiune: this.selectedGestiuneId } : {}),
          series: this.seriesNumber,
          nirNumber: parseInt(this.currentNumber),
          numar_document: this.nrDocument,
          data_document: this.dataDocument,
          vatNumberFurnizor: this.codeFiscalFurnizor,
          externalCompanyId: this.companyID,
          externalLocationId: this.selectedLocationId,
          vatNumber: this.vatNumber,
          nume_furnizor: this.nume,
          data_in_stoc: this.dataInStoc,
          data_scadentei: this.dataScadenta,
          tip_document: this.tipDocument,
          valoare: this.valoare,
          moneda: this.currency,
          precizie: this.precizie,
          invoice_supplier: this.invoiceSupplierId,
          items: itemsWithAdaos.map(product => {
            const nirItem = {
              denumire_produs_sau_serviciu: product.productName
                ? typeof product.productName === 'object'
                  ? product.productName.name
                  : product.productName
                : '',
              cod: product.nr,
              denumire_descriere_produs: product.productName
                ? typeof product.productName === 'object'
                  ? product.productName.name
                  : product.productName
                : '',
              categoria: product.categoria,
              u_m: product.um,
              // Trimite și cantități negative (ex. stornare); fallback doar dacă lipsește cantitatea
              cantitate: (product.cantitate != null && product.cantitate !== '')
                ? product.cantitate
                : product.quantityInvoiceSupplier,
              tva_percent: parseInt(product.tva),
              pret_fara_tva: product.pretFaraTva,
              valoare_calculata: product.valoareCalculata,
              gestiune: this.selectedGestiuneId || product.gestiune,
              posId: product.posId,
              pretVanzare: product.price,
              tvaProdusVanzare: product.tvaProdusVanzare,
              adaosLinie: product.adaosLinie,
              adaosTotal: product.adaosTotal,
              adaosProc: product.adaosProc,
              salePriceFaraTva: product.salePriceFaraTva,
              invoice_supplier_product_name: product.productInvoiceSupplier,
              invoice_supplier_quantity: product.quantityInvoiceSupplier,
              invoice_supplier_um: product.umInvoiceSupplier
            }

            if (this.isInvoiceSupplier) {
              nirItem.um_document = product.umDocument
              nirItem.cantitate_document = product.cantitateDocument
              nirItem.cantitate = product.cantitate
            }

            return nirItem
          }),
          extraFields: Object.entries(this.extraFields).map(([key, value]) => ({ key, value }))
        }
        await this.sendNIRToAPI(nirData)
      },
      async updateOrderWithANir (number) {
        const currentExternalDocs = this.myOrder.externalDocIds || {}

        const updateOrderPayload = {
          ...this.myOrder,
          externalDocIds: {
            ...currentExternalDocs,
            nir: {
              number
            }
          },
          status: 'generat nir'
        }

        try {
          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/order`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(updateOrderPayload)
          })

          if (!response.ok) {
            console.warn('Order update with aviz_id failed')
          } else {
            console.log('Order updated with aviz:', number)
          }
        } catch (err) {
          console.error('Error updating order with aviz_id:', err)
        }
      },
      escapeHtml (value) {
        return String(value == null ? '' : value)
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
      },
      formatTimestampMs (value) {
        if (value == null || value === '') return '-'
        const timestamp = Number(value)
        if (!Number.isFinite(timestamp)) return String(value)

        return new Intl.DateTimeFormat('ro-RO', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit'
        }).format(new Date(timestamp))
      },
      translateSaveError (error) {
        const translations = {
          'Stock ledger recovery is required before stock operations can continue':
            'Este necesară recuperarea registrului de stoc înainte de a continua operațiunile de stoc.'
        }

        return translations[error] || error
      },
      translateDetailKey (key) {
        const translations = {
          state: 'Stare',
          mutation_owner: 'Proprietar mutație',
          mutation_started_at_ms: 'Început mutație',
          lease_until_ms: 'Lease până la',
          recovery_reason: 'Motiv recuperare'
        }

        return translations[key] || key
      },
      translateDetailValue (key, value) {
        if (value == null || value === '') return '-'

        const translations = {
          RECOVERY_REQUIRED: 'Recuperare necesară',
          STOCK_LEDGER_MUTATION_LEASE_EXPIRED: 'Lease-ul mutației pe registrul de stoc a expirat'
        }

        if (typeof value === 'string' && translations[value]) {
          return translations[value]
        }

        if (typeof key === 'string' && key.endsWith('_ms')) {
          return this.formatTimestampMs(value)
        }

        if (typeof value === 'object') {
          try {
            return JSON.stringify(value)
          } catch (err) {
            return String(value)
          }
        }

        return String(value)
      },
      formatSaveError (data, status) {
        const fallback = 'A apărut o eroare la salvarea NIR-ului.'
        if (!data || typeof data !== 'object') {
          return status ? `${fallback}<br>Cod: ${status}` : fallback
        }

        const message = this.translateSaveError(data.error || data.message) || fallback
        const details = data.details

        if (details == null) {
          return this.escapeHtml(message)
        }

        if (typeof details === 'string') {
          return `${this.escapeHtml(message)}<br><br>${this.escapeHtml(details)}`
        }

        if (typeof details !== 'object') {
          return this.escapeHtml(message)
        }

        const rows = Object.keys(details).map(key => {
          const label = this.translateDetailKey(key)
          const value = this.translateDetailValue(key, details[key])
          return `<strong>${this.escapeHtml(label)}:</strong> ${this.escapeHtml(value)}`
        })

        if (!rows.length) {
          return this.escapeHtml(message)
        }

        return `${this.escapeHtml(message)}<br><br>${rows.join('<br>')}`
      },
      showSaveError (data, status) {
        swal.close()
        swal({
          title: 'Eroare',
          html: this.formatSaveError(data, status),
          type: 'error',
          confirmButtonText: 'OK'
        })
      },
      async sendNIRToAPI (nirData) {
        try {
          swal({
            type: 'info',
            title: 'Salvare în curs...',
            text: 'Se salvează NIR-ul. Așteaptă te rog.',
            allowOutsideClick: false,
            allowEscapeKey: false,
            showConfirmButton: false
          })

          if (this.isEdit && this.nrDocument) {
            nirData.updateRecord = true
          }

          const response = await fetch(`${process.env.API_BASE_URL_GESTIUNE}:4443/nir`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(nirData)
          })

          const data = await response.json().catch(() => null)

          if (!response.ok) {
            console.error('Error saving NIR:', data)
            this.showSaveError(data, response.status)
            return
          }

          console.log('NIR saved successfully:', data)

          swal.close()

          if (this.isNir && data.nir.numar_document) {
            await this.updateOrderWithANir(data.nir.numar_document)
          }

          swal({
            title: 'Success',
            text: 'NIR saved successfully.',
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          })

          this.$bus.$emit('refresh')
          this.$bus.$emit('close-modal')
        } catch (error) {
          console.error('Error saving NIR:', error)
          this.showSaveError(
            (error && error.payload) || { error: error && error.message },
            error && error.status
          )
        }
      },
      editRow (row) {
        const index = this.tableData.indexOf(row)
        if (index === -1) return

        this.editIndex = index
        this.selectedCategory = row.categoria || ''

        const selectedProduct = {
          name: row.productName || '',
          product_code: row.nr || '',
          categorie: (row.categoria || '').toLowerCase().replace(/\s+/g, '_'),
          vat_percent: row.tva,
          um: row.um,
          posId: row.posId || '',
          price: row.price,
          adaosLinie: row.adaosLinie || 0,
          adaosTotal: row.adaosTotal || 0,
          adaosProc: row.adaosProc || 0,
          salePriceFaraTva: row.salePriceFaraTva || 0
        }

        console.log('ROW', row)
        this.selectedQuantity = row.cantitateDocument != null
          ? row.cantitateDocument
          : (row.cantitate || 0)

        // Deschide modalul mai întâi
        this.$modal.show('addProductModal')

        console.log(row)

        // Așteaptă să se monteze DOM-ul din modal
        this.$nextTick(() => {
          this.item = {
            nr: row.nr || '',
            productName: selectedProduct,
            categoria: row.categoria || '',
            gestiune: row.gestiune || '',
            um: row.um,
            cantitate: row.cantitate || this.selectedQuantity,
            tva: row.tva != null ? Number(row.tva) : null,
            pretFaraTva: row.pretIntrodus != null ? row.pretIntrodus : (row.pretFaraTva || null),
            currency: row.currency || 'RON',
            valoare: row.valoare || 'fara_tva',
            posId: row.posId || '',
            umDocument: row.umDocument || row.um,

            price: row.price,
            adaosLinie: row.adaosLinie || 0,
            adaosTotal: row.adaosTotal || 0,
            adaosProc: row.adaosProc || 0,
            salePriceFaraTva: row.salePriceFaraTva || 0
          }
          this.addItem = false

          // Rulează simularea selectării produsului după ce item a fost setat
          this.onProductSelect(selectedProduct)

          // Restaurează UM document (ex: KG) dacă diferă de UM produs (ex: G)
          this.$nextTick(() => {
            const docUm = this.normalizeUm(row.umDocument)
            const productUm = this.normalizeUm(row.um)
            if (docUm && docUm !== productUm && this.unit_calc && this.unit_calc.length) {
              const unit = this.unit_calc.find(u => this.normalizeUm(u.short) === docUm)
              if (unit) {
                this.selectedUnit = unit
                this.previousSelectedUnit = unit
                this.selectedQuantity = row.cantitateDocument != null
                  ? row.cantitateDocument
                  : parseFloat((Number(row.cantitate || 0) / this.getBaseUnitsPerDocumentUnit(unit)).toFixed(6))
              }
            } else {
              this.previousSelectedUnit = this.selectedUnit
            }
          })
        })
      },
      deleteRow (row) {
        const index = this.tableData.indexOf(row)

        if (index !== -1) {
          this.tableData.splice(index, 1)
        }
      },
      openAddProductModal () {
        this.addItem = true

        this.editIndex = null
        this.resetItem()
        this.$modal.show('addProductModal')
      },
      resetItem () {
        this.selectedCategory = ''
        this.selectedQuantity = ''
        this.totalValue = 0
        this.selectedUnit = ''
        this.previousSelectedUnit = ''
        this.unit_calc = []

        this.item = {
          nr: '',
          productName: null,
          categoria: '',
          gestiune: this.defaultGestiuneId || '',
          um: '',
          cantitate: null,
          tva: '',
          price: null,
          adaosTotal: null,
          adaosProc: null,
          adaosLinie: null,
          pretFaraTva: null,
          currency: 'RON',
          valoare: 'fara_tva'
        }
      },
      goBack () {
        this.$bus.$emit('refresh')
        this.$bus.$emit('close-modal')
      }
    }
  }
</script>
<style scoped>
.nir-info-note {
  margin-bottom: 0;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #25396F;
  background: rgba(103, 75, 210, 0.12);
  border: 1px solid #674BD2;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(103, 75, 210, 0.18);
}

.nir-info-note >>> strong {
  font-weight: 700;
  color: #674BD2;
}
.v-select input[type=search], .v-select input[type=search]:focus,
.v-select.searchable .dropdown-toggle {
    min-height: 46px;
    height: 46px;
}
.btn-primary {
  padding: 5px 50px;
}
.button-group {
    display: flex; /* Folosește flexbox pentru alinierea orizontală */
    justify-content: flex-end; /* Aliniază butoanele la dreapta */
}
.button-group .btn {
    margin-right: 10px; /* Adaugă un spațiu între butoane */
}
.button-group .btn:last-child {
    margin-right: 0; /* Elimină marginea dreaptă pentru ultimul buton */
}
.totals-container {
  margin-top: 20px;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.v-select .dropdown-toggle {
  height: 46px !important;
}
.supplier-product-name {
  margin-top: 10px;
  display: block;
  font-size: 13px;
  background: #7777df;
  color: #fff;
  border-radius: 4px;
  width: auto;
  min-width: auto;
  max-width: max-content;
  padding: 3px 5px;
}
.invoice-product-wrapper .supplier-product-name {
  margin-top: 0;
  margin-bottom: 6px;
}
.invoice-supplier-um-edit {
  margin-top: 6px;
}
.invoice-supplier-select,
.invoice-supplier-qty {
  width: 100px;
  display: block;
  margin-top: 4px;
}
.invoice-supplier-value {
  width: 130px;
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
}
.invoice-supplier-price {
  width: 130px;
  display: block;
  margin-top: 4px;
  font-size: 14px;
  font-weight: 500;
}
.supplier-product-hint {
  display: block;
  font-size: 11px;
  color: #666;
  margin-top: 2px;
}
.table thead tr > th {
  font-size: 13px;
}
.table > tbody > tr > td {
  padding: 7px 11px;
}
.total-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 440px;
  font-size: 18px;
  margin-bottom: 5px;
}

.table > tbody > tr > td {
  font-size: 12px;
}

.total-row .label {
  font-weight: 500;
  color: #25396F;
}

.total-row .value {
  font-weight: 600;
  color: #25396F;
}

.total-final .label {
  font-size: 18px;
  font-weight: bold;
}
.addProductModal .vm--modal {}
.total-final .value {
  font-size: 18px;
  font-weight: bold;
}
.v-select-wrapper {
  position: relative;
}
.v-select-loader {
  position: absolute;
  right: 25px;
  top: 50%;
  transform: translateY(-50%);
  border: 3px solid #e0e0e0;     /* mai deschis */
  border-top: 3px solid #007bff;  /* mai contrastant */
  border-radius: 50%;
  width: 24px;                    /* mai mare */
  height: 24px;
  animation: spin 0.8s linear infinite;
}
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.el-table th > .cell {
  font-size: 13px;
}
.arrow-box {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  border: 1px solid #674BD2;
  border-radius: 6px;
  color: #674BD2;
  font-size: 18px;
  cursor: pointer;
  transition: all 0.2s;
}

.arrow-box:hover {
  background-color: #674BD2;
  color: #fff;
}

.custom-dropdown-menu {
  min-width: 140px;
}

.el-table th > .cell {
  font-size: 12px;
}

</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Management/Entries/ManagementEntriesForm.vue